// Minimal client-side logger. Sentry breadcrumbs land in Plan 10.
type Level = "debug" | "info" | "warn" | "error"

export class Logger {
  readonly #name: string
  constructor(opts: { name: string }) {
    this.#name = opts.name
  }
  debug(msg: string, ctx?: Record<string, unknown>): void {
    this.#emit("debug", msg, ctx)
  }
  info(msg: string, ctx?: Record<string, unknown>): void {
    this.#emit("info", msg, ctx)
  }
  warn(msg: string, ctx?: Record<string, unknown>): void {
    this.#emit("warn", msg, ctx)
  }
  error(msg: string, ctx?: Record<string, unknown>): void {
    this.#emit("error", msg, ctx)
  }
  #emit(level: Level, msg: string, ctx?: Record<string, unknown>): void {
    const line = { level, name: this.#name, msg, ...ctx, ts: new Date().toISOString() }
    console[level === "warn" ? "warn" : level === "error" ? "error" : "log"](line)
  }
}
